import React from "react";
import { useState } from "react";
import { useLayoutEffect } from "react";
import { getTransactions } from "../../services";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import moment from "moment";

const Transactions = (props) => {
  const [transactions, setTransactions] = useState([]);

  useLayoutEffect(() => {
    getTransactions().then((response) => {
      console.log(response.data);
      const result = response.data.map((ele) => {
        return {
          request: {
            energy:ele.request_info.energy,
            maxPrice:ele.request_info.maxPrice,
            minPrice:ele.request_info.minPrice,
          },
          offer: {
            energy:ele.offer_info.energy,
            price:ele.offer_info.price,
          },
          created:moment(ele.createdAt).format("DD-MM-YYYY HH:mm a"),
        };
      });
      setTransactions(result);
    });
  }, []);

  return (
    <div className="transactions">
      <h3>Transactions</h3>
      <div className="card">
        <DataTable value={transactions} responsiveLayout="scroll">
          <Column field="request.energy" header="Request Energy"></Column>
          <Column field="request.maxPrice" header="Request Max Price"></Column>
          <Column field="request.minPrice" header="Request Min Price"></Column>
          <Column field="offer.energy" header="Offer Energy"></Column>
          <Column field="offer.price" header="Offer Price"></Column>
          <Column field="created" header="Date"></Column>
        </DataTable>
      </div>
    </div>
  );
};

export default Transactions;
